/*! js-cookie v3.0.0 | MIT */
;
(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global = global || self, (function () {
    var current = global.Cookies;
    var exports = global.Cookies = factory();
    exports.noConflict = function () { global.Cookies = current; return exports; };
  }()));
}(this, (function () { 'use strict';

  /* eslint-disable no-var */
  function assign (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        target[key] = source[key];
      }
    }
    return target
  }
  /* eslint-enable no-var */

  /* eslint-disable no-var */
  var defaultConverter = {
    read: function (value) {
      return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent)
    },
    write: function (value) {
      return encodeURIComponent(value).replace(
        /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
        decodeURIComponent
      )
    }
  };
  /* eslint-enable no-var */

  /* eslint-disable no-var */

  function init (converter, defaultAttributes) {
    function set (key, value, attributes) {
      if (typeof document === 'undefined') {
        return
      }

      attributes = assign({}, defaultAttributes, attributes);

      if (typeof attributes.expires === 'number') {
        attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
      }
      if (attributes.expires) {
        attributes.expires = attributes.expires.toUTCString();
      }

      key = encodeURIComponent(key)
        .replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent)
        .replace(/[()]/g, escape);

      value = converter.write(value, key);

      var stringifiedAttributes = '';
      for (var attributeName in attributes) {
        if (!attributes[attributeName]) {
          continue
        }

        stringifiedAttributes += '; ' + attributeName;

        if (attributes[attributeName] === true) {
          continue
        }

        // Considers RFC 6265 section 5.2:
        // ...
        // 3.  If the remaining unparsed-attributes contains a %x3B (";")
        //     character:
        // Consume the characters of the unparsed-attributes up to,
        // not including, the first %x3B (";") character.
        // ...
        stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
      }

      return (document.cookie = key + '=' + value + stringifiedAttributes)
    }

    function get (key) {
      if (typeof document === 'undefined' || (arguments.length && !key)) {
        return
      }

      // To prevent the for loop in the first place assign an empty array
      // in case there are no cookies at all.
      var cookies = document.cookie ? document.cookie.split('; ') : [];
      var jar = {};
      for (var i = 0; i < cookies.length; i++) {
        var parts = cookies[i].split('=');
        var value = parts.slice(1).join('=');

        if (value[0] === '"') {
          value = value.slice(1, -1);
        }

        try {
          var foundKey = defaultConverter.read(parts[0]);
          jar[foundKey] = converter.read(value, foundKey);

          if (key === foundKey) {
            break
          }
        } catch (e) {}
      }

      return key ? jar[key] : jar
    }

    return Object.create(
      {
        set: set,
        get: get,
        remove: function (key, attributes) {
          set(
            key,
            '',
            assign({}, attributes, {
              expires: -1
            })
          );
        },
        withAttributes: function (attributes) {
          return init(this.converter, assign({}, this.attributes, attributes))
        },
        withConverter: function (converter) {
          return init(assign({}, this.converter, converter), this.attributes)
        }
      },
      {
        attributes: { value: Object.freeze(defaultAttributes) },
        converter: { value: Object.freeze(converter) }
      }
    )
  }

  var api = init(defaultConverter, { path: '/' });
  /* eslint-enable no-var */

  return api;

})));

(function($) {
    /**
     * UTM -> window.mwfUtmData helper
     */
    class MWF_UTM {
    	constructor() {
        this.utmResults = {
          'utm_content': null,
          'utm_campaign': null,
          'utm_medium': null,
          'utm_source': null,
          'gclid': null
        };
    
        window.mwfUtmData = window.mwfUtmData || {};
    
        this.parseUtmsInUrl();
        this.setReferrer();
        this.setUtmData();
      }
    
      parseUtmsInUrl () {
        let query = window.location.href;
              
        if (query.indexOf('?') != -1){
          query = query.split('?');		
          query = query[1];
        }
    
        let parsedQuery = query.split("&");
        let allowedKeys = Object.keys(this.utmResults);
    
        for (var i = 0; i < parsedQuery.length; i++) {
          let pair = parsedQuery[i].split('=');
          let key = decodeURIComponent(pair[0]);
    
          if (key.length === 0 || allowedKeys.indexOf(key) === -1) {
            continue;
          }
    
          let value = decodeURIComponent(pair[1].replace("+"," "));
          this.utmResults[key] = value;
        }
      };
    
      setReferrer () {
        this.utmResults.referrer = document.referrer;
    
        if (!!this.utmResults.referrer) {
          this.utmResults.referrer = this.utmResults.referrer.replace(/^(?:https?:\/\/)?(?:www\.)?/i, '').split('/')[0];
          this.utmResults.referrer = this.utmResults.referrer.replace(/[^a-z0-9\-\_\.\/\+\@\?\&ąćęłńóśźż]/gmi, '');
        } else {
          this.utmResults.referrer = null;
        }
    
        if (this.utmResults.referrer === window.location.host) {
          this.utmResults.referrer = null;
        }
      }
    
      setUtmData () {
        // UTM SOURCE
        if (this.utmResults.utm_source !== null) {
          window.mwfUtmData.utm_source = this.utmResults.utm_source;
        } else if (this.utmResults.gclid !== null) {
          window.mwfUtmData.utm_source = 'google';
        } else if (!window.mwfUtmData.utm_source && this.utmResults.referrer !== null) {
          window.mwfUtmData.utm_source = this.utmResults.referrer;
          window.mwfUtmData.utm_medium = 'referral';
        }
    
        // UTM MEDIUM
        if (this.utmResults.utm_medium !== null) {
          window.mwfUtmData.utm_medium = this.utmResults.utm_medium;
        } else if (this.utmResults.gclid !== null) {
          window.mwfUtmData.utm_medium = 'cpc';
        }
    
        // UTM CAMPAIGN
        if (this.utmResults.utm_campaign !== null) {
          window.mwfUtmData.utm_campaign = this.utmResults.utm_campaign;
        }
    
        // UTM CONTENT
        if (this.utmResults.utm_content !== null) {
          window.mwfUtmData.utm_content = this.utmResults.utm_content;
        }
      }
    }
    
    +/**
     * Cookie Banner
     */
    
    /*
     Connections:
     -------------------------------------------------------------------------------
     * google - GA4, Google Ads
     * facebook - Meta Pixel
     * players - every player on website: YouTube, Vimeo
     * marketing - chat, Convertbox
     * 
    */
    
    (function ($) {
        var config = {
            debugMode: true,
            userConsents: {
                google: false,
                facebook: false,
                players: false,
                marketing: false
            },
            userUUID: 'not-set',
            groups: [
                'google',
                'facebook',
                'players',
                'marketing'
            ],
            allowedGroups: []
        };
      
        var UI = {
            basicWindow: $('.mwf-cn-info'),
            extendedWindow: $('.mwf-cn-info-extended'),
            buttons: {
                basicShowExtended: $('.mwf-cn-info-button-show-extended'),
                basicAcceptAll: $('.mwf-cn-info-button-accept-all'),
                basicRejectAll: $('.mwf-cn-info-button-reject-all'),
                extendedAcceptAll: $('.mwf-cn-info-extended-button-accept-all'),
                extendedSaveConfig: $('.mwf-cn-info-extended-button-save-consent'),
                extendedNotNow: $('.mwf-cn-info-extended-button-close-without-save')
            },
            checkboxes: {
                google: $('.mwf-cn-consent-checkbox[data-consent-type="google"]'),
                facebook: $('.mwf-cn-consent-checkbox[data-consent-type="facebook"]'),
                players: $('.mwf-cn-consent-checkbox[data-consent-type="players"]'),
                marketing: $('.mwf-cn-consent-checkbox[data-consent-type="marketing"]')
            }
        };
      
        if (UI.basicWindow.length) {
            initEvents();
            initPublicAPI();
            checkConfig(config);
        }
      
        function checkConfig () {
            var configFromCookie = Cookies.get(window.mwfCNConfig.cookieName, { path: window.mwfCNConfig.path });
      
            // When no config - show popup
            if (!configFromCookie) {
                if (config.debugMode) {
                    console.log('⛔️ Consent config not found - showing popup');
                }
        
                config.userUUID = generateUUID();
                
                // Not open on privacy policy page
                if (!$(document.body).hasClass('privacy-policy')) {
                    showPopup();
                }
    
                return;
            }
      
            // otherwise - load config without showing popup
            loadConfig(configFromCookie);
        }
      
        function loadConfig (configFromCookie) {
            config.userConsents.google = configFromCookie.indexOf('google') > -1;
            config.userConsents.facebook = configFromCookie.indexOf('facebook') > -1;
            config.userConsents.players = configFromCookie.indexOf('players') > -1;
            config.userConsents.marketing = configFromCookie.indexOf('marketing') > -1;
            let configParts = configFromCookie.split('||');
    
            if (configParts[1]) {
                config.userUUID = configParts[1].replace(/[^a-zA-Z0-9\-]/gmi, '');
            } else {
                config.userUUID = generateUUID();
            }
      
            for (var i = 0; i < config.groups.length; i++) {
                var groupName = config.groups[i];
      
                if (config.userConsents[groupName]) {
                    config.allowedGroups.push(groupName);
                }
            }
      
            if (config.debugMode) {
                console.log('⚙️ Founded config:', JSON.parse(JSON.stringify(config.userConsents)));
            }
        }
      
        function initEvents () {
            $(document).find('a[href="#cookie-settings"]').on('click', e => {
                e.preventDefault();
                showExtendedPopup();
            });
      
            UI.buttons.basicShowExtended.on('click', e => {
                e.preventDefault();
                closePopup();
                showExtendedPopup();
            });
      
            UI.buttons.basicAcceptAll.on('click', e => {
                e.preventDefault();
                giveConsentForAll();
                closePopup();
            });
      
            UI.buttons.basicRejectAll.on('click', e => {
                e.preventDefault();
                resetCookieConfig();
                closePopup();
            });
      
            UI.buttons.extendedAcceptAll.on('click', e => {
                e.preventDefault();
                giveConsentForAll();
                closeExtendedPopup();
            });
      
            UI.buttons.extendedSaveConfig.on('click', e => {
                e.preventDefault();
                saveConsent();
                closeExtendedPopup();
            });
      
            UI.buttons.extendedNotNow.on('click', e => {
                e.preventDefault();
                closeExtendedPopup();
    
                var configFromCookie = Cookies.get(window.mwfCNConfig.cookieName, { path: window.mwfCNConfig.path });
      
                if (!configFromCookie) {
                    showPopup();
                }
            });
        }
      
        function setCheckboxes () {
            for (var i = 0; i < config.groups.length; i++) {
                var group = config.groups[i];
      
                if (config.userConsents[group]) {
                    UI.checkboxes[group].prop('checked', true);
                } else {
                    UI.checkboxes[group].prop('checked', false);
                }
            }
        }
      
        function initPublicAPI () {
            window.mwfCookieBanner = {
                giveConsentAndSave: function (type) {
                    giveConsentAndSave(type);
                },
                giveConsentAndSaveAndLoad: function (type) {
                    giveConsentAndSave(type, true);
                },
                showExtendedPopup: function () {
                    showExtendedPopup();
                },
                getConsentStatus: function (type) {
                    getConsentStatus(type);
                }
            };
        }
      
        function showPopup () {
            UI.basicWindow.removeClass('is-hidden');
        }
      
        function closePopup () {
            UI.basicWindow.addClass('is-hidden');
        }
      
        function showExtendedPopup () {
            UI.extendedWindow.removeClass('is-hidden');
            $(document.body).addClass('no-scroll');
            setCheckboxes();
        }
      
        function closeExtendedPopup () {
            UI.extendedWindow.addClass('is-hidden');
            $(document.body).removeClass('no-scroll');
        }
      
        function giveConsentForAll () {
            giveConsent('google');
            giveConsent('facebook');
            giveConsent('players');
            giveConsent('marketing');
            saveConsentConfigInCookie(false);
        }
      
        function giveConsent (type, forceOnLoad = false) {
            if (config.debugMode) {
                console.log('✅ User gave consent:', type);
            }
      
            // If consent has been previously given - do nothing
            if (config.allowedGroups.indexOf(type) > -1) {
                return;
            }
      
            config.userConsents[type] = true;
    
            if (type === 'google') {
                allowGoogle();
                return;
            }
    
            if (type === 'facebook') {
                allowFB();
                return;
            }
      
            if (type === 'players') {
                allowPlayers();
                return;
            }
      
            if (type === 'marketing') {
                allowMarketing();
                return;
            }
        }
      
        function giveConsentAndSave (type, forceOnLoad = false) {
            giveConsent(type, forceOnLoad);
            saveConsentConfigInCookie(false);
        }
      
        function saveConsent () {
            var consentCompare = compareConsents();
            setConsentBasedOnCheckboxes();
      
            // if some consent has been removed
            if (consentCompare === 'some-rejected') {
                saveConsentConfigInCookie(true);
                return;
            }
      
            // otherwise - if some consent has been added
            saveConsentConfigInCookie(false);
        }
      
        function setConsentBasedOnCheckboxes () {
            for (var i = 0; i < config.groups.length; i++) { 
                var group = config.groups[i];
      
                if (!!UI.checkboxes[group].prop('checked')) {
                    giveConsent(group);
                }
      
                config.userConsents[group] = !!UI.checkboxes[group].prop('checked');
            }
        }
      
        function saveConsentConfigInCookie (reloadNeeded = false) {
            var configToSave = [];
      
            for (var i = 0; i < config.groups.length; i++) {
                var group = config.groups[i];
      
                if (config.userConsents[group]) {
                    configToSave.push(group);
                }
            }
      
            if (configToSave.length) {
                Cookies.set(window.mwfCNConfig.cookieName, configToSave.join(';') + '||' + config.userUUID, { expires: 180, path: window.mwfCNConfig.path });
      
                if (config.debugMode) {
                    console.log('🍪 Consent config saved in the cookie');
                }
            } else {
                Cookies.set(window.mwfCNConfig.cookieName, 'null' + '||' + config.userUUID, { expires: 180, path: window.mwfCNConfig.path });
            }
    
            let dataToSave = {
                consent_id: config.userUUID,
                consent_revision: window.mwfCNConfig.cookieName,
                consent_content: configToSave.join(';'),
                consent_timestamp: +new Date(),
                url: window.location.pathname,
                delivery: 'sendBeacon' in navigator ? 'beacon' : 'ajax'
            };
          
            if ('sendBeacon' in navigator) {
                const formData = $.param(dataToSave);
                const blob = new Blob(
                    [formData], 
                    {
                        type : 'application/x-www-form-urlencoded'
                    }
                );
                navigator.sendBeacon('https://malawielkafirma.pl/wp-json/cmp/v1/save', blob);
                
                if (reloadNeeded) {
                    setTimeout(() => {
                        window.location.reload();
                    }, 500);
                }
            } else {
                $.ajax({
                    url: 'https://malawielkafirma.pl/wp-json/cmp/v1/save',
                    type: 'POST',
                    contentType: 'application/x-www-form-urlencoded',
                    data: $.param(dataToSave),
                    success: function () {
                        if (reloadNeeded) {
                            setTimeout(() => {
                                window.location.reload();
                            }, 500);
                        }
                    },
                    fail: function () {
                        if (reloadNeeded) {
                            setTimeout(() => {
                                window.location.reload();
                            }, 500);
                        }
                    }
                });
            }
        }
      
        function resetCookieConfig () {
            Cookies.set(window.mwfCNConfig.cookieName, 'null' + '||' + config.userUUID, { expires: 180, path: window.mwfCNConfig.path });
      
            if (config.debugMode) {
              console.log('🗑 User rejected all cookies - save empty config cookie');
            }
    
            let dataToSave = {
                consent_id: config.userUUID,
                consent_revision: window.mwfCNConfig.cookieName,
                consent_content: '',
                consent_timestamp: +new Date(),
                url: window.location.pathname,
                delivery: 'sendBeacon' in navigator ? 'beacon' : 'ajax'
            };
          
            if ('sendBeacon' in navigator) {
                const formData = $.param(dataToSave);
                const blob = new Blob(
                    [formData], 
                    {
                        type : 'application/x-www-form-urlencoded'
                    }
                );
                navigator.sendBeacon('https://malawielkafirma.pl/wp-json/cmp/v1/save', blob);
            } else {
                $.ajax({
                    url: 'https://malawielkafirma.pl/wp-json/cmp/v1/save',
                    type: 'POST',
                    contentType: 'application/x-www-form-urlencoded',
                    data: $.param(dataToSave)
                });
            }
        }
      
        function compareConsents () {
            var someRejected = false;
      
            for (var i = 0; i < config.groups.length; i++) {
                var group = config.groups[i];
      
                if (config.userConsents[group] && !UI.checkboxes[group].prop('checked')) {
                    someRejected = true;
    
                    if (group === 'google' && typeof gtag === 'function') {
                        gtag('consent', 'update', {
                            ad_user_data: 'denied',
                            ad_personalization: 'denied',
                            ad_storage: 'denied',
                            analytics_storage: 'denied'
                        });
                    }
                }
            }
      
            if (someRejected) {
                if (config.debugMode) {
                    console.log('🔄 Some consents has been rejected - website reload needed');
                }
      
                return 'some-rejected';
            }
      
            if (config.debugMode) {
                console.log('ℹ️ User not rejected any consents - website reload not needed');
            }
      
            return 'some-added-or-not-changed';
        }
      
        function getConsentStatus (type) {
            return !!config.userConsents[type];
        }
      
        function allowGoogle () {
            if (window.mwfUnlocked.indexOf('google') > -1) {
                return;
            }
      
            window.mwfUnlockConsentedScript('google', 'head', true);
        }
    
        function allowFB () {
            if (window.mwfUnlocked.indexOf('facebook') > -1) {
                return;
            }
        
            window.mwfUnlockConsentedScript('facebook', 'head', true);
        }
        
        function allowPlayers () {
            if (window.mwfUnlocked.indexOf('players') > -1) {
                return;
            }
      
            window.mwfUnlockPlayers(true);
        }
        
        function allowMarketing () {
            if (window.mwfUnlocked.indexOf('marketing') > -1) {
                return;
            }
      
            window.mwfUnlockConsentedScript('marketing', 'head', true);
            window.mwfUnlockMarketing(true);
        }
    
        function generateUUID () {
            var crypto = window.crypto || window.msCrypto;
        
            if (crypto && crypto.randomUUID) {
                let uuid = crypto.randomUUID();
                return uuid;
            }
        
            if (window.Uint8Array && crypto && crypto.getRandomValues) {
                let bytes = new Uint8Array(16);
                crypto.getRandomValues(bytes);
                bytes[6] = (bytes[6] & 0x0f) | 0x40;
                bytes[8] = (bytes[8] & 0x3f) | 0x80;
                let uuid = Array.prototype.map.call(bytes, (b, i) => {
                    return ((b < 16) ? '0' : '') + b.toString(16) + (((i % 2) && (i < 10) && (i > 2)) ? "-" : "");
                }).join('');
                return uuid;
            }
        
            var dt = new Date().getTime();
            var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                var r = (dt + Math.random()*16)%16 | 0;
                dt = Math.floor(dt/16);
                return (c == 'x' ? r : (r&0x3|0x8)).toString(16);
            });
        
            return uuid;
        }
      })(jQuery);
    new MWF_UTM();
})(jQuery);